/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Sai Teja",
  description:
    "A passionate individual who always thrives to work on end to end products which develop sustainable and scalable social and technical systems to create impact.",
  og: {
    title: "Sai Teja Portfolio",
    type: "website",
    url: "https://saiteja13427.github.io",
  },
};

//Home Page
const greeting = {
  title: "Sai Teja",
  logo_name: "Sai Teja",
  nickname: "saai_tejaa",
  subTitle:
    "A passionate individual who always thrives to work on end to end products which develop sustainable and scalable social and technical systems to create impact.",
  resumeLink:
    "https://swiy.co/resume",
  portfolio_repository: "https://github.com/saiteja13427",
  githubProfile: "https://github.com/saiteja13427",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/saiteja13427",
  // linkedin: "https://www.linkedin.com/in/saai-tejaa/",
  // gmail: "saiteja13427@gmail.com",
  // gitlab: "https://gitlab.com/ashutoshhathidara98",
  // facebook: "https://www.facebook.com/laymanbrother.19/",
  // twitter: "https://twitter.com/ashutosh_1919",
  // instagram: "https://www.instagram.com/layman_brother/"

  {
    name: "Github",
    link: "https://github.com/saiteja13427",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/saai-tejaa/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  // {
  //   name: "YouTube",
  //   link: "https://www.youtube.com/channel/UC_amoXmmxSY9KusoDczDTXQ",
  //   fontAwesomeIcon: "fa-youtube", // Reference https://fontawesome.com/icons/youtube?style=brands
  //   backgroundColor: "#FF0000", // Reference https://simpleicons.org/?q=youtube
  // },
  {
    name: "Gmail",
    link: "mailto:saiteja13427@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Twitter",
    link: "https://twitter.com/saai_tejaa",
    fontAwesomeIcon: "fa-twitter", // Reference https://fontawesome.com/icons/twitter?style=brands
    backgroundColor: "#1DA1F2", // Reference https://simpleicons.org/?q=twitter
  },
  // {
  //   name: "Facebook",
  //   link: "https://www.facebook.com/laymanbrother.19/",
  //   fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
  //   backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  // },
  {
    name: "Instagram",
    link: "https://www.instagram.com/saai_tejaa/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
];

const skills = {
  data: [
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building resposive website front end using React and Redux",
        "⚡ Developing mobile applications using React Native",
        "⚡ Creating application backend in Node & Express",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "TypeScript",
          fontAwesomeClassname: "simple-icons:typescript",
          style: {
            backgroundColor: "#fff",
            color: " #007acc ",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "Express",
          fontAwesomeClassname: "simple-icons:express",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#589636",
          },
        },
      ],
    },
    {
      title: "Cloud Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience working on multiple cloud platforms",
        "⚡ Experience in working with multiple cloud databases",
        "⚡ Worked with docker and kubernetes",
      ],
      softwareSkills: [
        {
          skillName: "Digital Ocean",
          fontAwesomeClassname: "cib:digital-ocean",
          style: {
            color: "#008bcf",
          },
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        // {
        //   skillName: "Azure",
        //   fontAwesomeClassname: "simple-icons:microsoftazure",
        //   style: {
        //     color: "#0089D6",
        //   },
        // },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "Heroku",
          fontAwesomeClassname: "simple-icons:heroku",
          style: {
            color: "#6762a6",
          },
        },

        {
          skillName: "MongoDB Atlas",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "simple-icons:kubernetes",
          style: {
            color: "#326CE5",
          },
        },
      ],
    },
    // {
    //   title: "UI/UX Design",
    //   fileName: "DesignImg",
    //   skills: [
    //     "⚡ Designing highly attractive user interface for mobile and web applications",
    //     "⚡ Customizing logo designs and building logos from scratch",
    //     "⚡ Creating the flow of application functionalities to optimize user experience",
    //   ],
    //   softwareSkills: [
    //     {
    //       skillName: "Adobe XD",
    //       fontAwesomeClassname: "simple-icons:adobexd",
    //       style: {
    //         color: "#FF2BC2",
    //       },
    //     },
    //     {
    //       skillName: "Figma",
    //       fontAwesomeClassname: "simple-icons:figma",
    //       style: {
    //         color: "#F24E1E",
    //       },
    //     },
    //     {
    //       skillName: "Adobe Illustrator",
    //       fontAwesomeClassname: "simple-icons:adobeillustrator",
    //       style: {
    //         color: "#FF7C00",
    //       },
    //     },
    //     {
    //       skillName: "Inkscape",
    //       fontAwesomeClassname: "simple-icons:inkscape",
    //       style: {
    //         color: "#000000",
    //       },
    //     },
    //   ],
    // },
    {
      title: "Distributed Computing",
      fileName: "DesignImg",
      skills: [
        "⚡ Distributed data processing using Hadoop, Spark etc",
        "⚡ Deep understanding of Map Reduce",
        "⚡ Good Understanding on Distributed Systems",
      ],
      softwareSkills: [
        {
          skillName: "Apache Hadoop",
          fontAwesomeClassname: "logos:hadoop",
        },
        {
          skillName: "Apache Spark",
          fontAwesomeClassname: "cib:apache-spark",
          style: {
            color: "#e4682a",
          },
        },
      ],
    },

  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/saiteja167",
    },
    {
      siteName: "Codechef",
      iconifyClassname: "simple-icons:codechef",
      style: {
        color: "#5B4638",
      },
      profileLink: "https://www.codechef.com/users/saiteja167",
    },
    {
      siteName: "Codeforces",
      iconifyClassname: "simple-icons:codeforces",
      style: {
        color: "#1F8ACB",
      },
      profileLink: "http://codeforces.com/profile/saiteja167",
    },
    {
      siteName: "Hackerearth",
      iconifyClassname: "simple-icons:hackerearth",
      style: {
        color: "#323754",
      },
      profileLink: "https://www.hackerearth.com/@saiteja13427",
    },
    {
      siteName: "Leetcode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#f9a825",
      },
      profileLink: "https://leetcode.com/saiteja13427/",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "University of Hyderabad",
      subtitle: "Integrated MTech in Computer Sciences",
      logo_path: "uohyd.png",
      alt_name: "IIITDM Kurnool",
      duration: "2018 - Present",
      descriptions: [
        "⚡ I have studied various software engineering subjects like DS, Algorithms, DBMS, OS, CD, Networking etc.",
        "⚡ I also did courses specialised in distributed computing and distributed data processing",
        "⚡ I hold a CGPA of 9.2 / 10",
      ],
      website_link: "http://uohyd.ac.in",
    },
    {
      title: "Vijay Ratna Junior College",
      subtitle: "11th & 12th (MPC)",
      logo_path: "vijayratna.png",
      alt_name: "Vijay Ratna",
      duration: "2016 - 2018",
      descriptions: [
        "⚡ Did my 11th and 12th with Maths, Physics and Chemistry",
        "⚡ Also did my IIT-JEE coaching from the prestigious Ramaiah Institute",
        "⚡ Scored 984/1000 in the boards",
        "⚡ Was in top 1 percentile in JEE Mains and ranked 2000 in TS EAMCET",
      ],
      // website_link: "http://uohyd.ac.in",
    },
    {
      title: "Dilsukhnagar Public School",
      subtitle: "10th",
      logo_path: "dps.png",
      alt_name: "Dilsukhnagar Public School",
      duration: "2015 - 2016",
      descriptions: [
        "⚡ Was the topper at DPS and won several competitions during school",
        "⚡ Scored 9.8/10 GPA in boards",
      ],
      // website_link: "http://uohyd.ac.in",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Postman Student Expert",
      subtitle: "- Postman",
      logo_path: "postman.png",
      certificate_link:
        "https://badgr.com/public/assertions/0aIjwQ4sTjuMWZ5R4vzvoA?identity__email=saiteja13427@gmail.com",
      alt_name: "Postman",
      color_code: "#ffc869",
    },
    {
      title: "Complete Web Development Bootcamp",
      subtitle: "- Angela Yu (App Brewery)",
      logo_path: "app-brewery.png",
      certificate_link:
        "https://www.udemy.com/certificate/UC-cac75131-5a3b-4107-8398-3894a7e5a073/",
      alt_name: "udemy.com",
      color_code: "#f8fad9",
    },
    {
      title: "Fundamentals of Internet",
      subtitle: "- Codedamn",
      logo_path: "codedamn.png",
      certificate_link:
        "https://codedamn.com/certificate/verify/7d5ddb168233c07afc21e54d2d522aeaf3cba177",
      alt_name: "Codedamn",
      color_code: "#f7abab",
    },
    {
      title: "Nodejs Masterclass",
      subtitle: "- Brad Traversy",
      logo_path: "traversy.png",
      certificate_link:
        "https://www.udemy.com/certificate/UC-62e695bd-8ae5-4a1b-9bb4-f1b6d6b662ac/",
      alt_name: "Traversy",
      color_code: "#c7f0fc",
    },
    {
      title: "Complete Typescript Bootcamp",
      subtitle: "- Maximilian Schwarzmüller (Academind)",
      logo_path: "academind.png",
      certificate_link:
        "https://www.udemy.com/certificate/UC-05e0a4bc-7a30-455f-bfec-aea041a18f29/",
      alt_name: "Academind",
      color_code: "#fad893",
    },
    // {
    //   title: "Advanced Data Science",
    //   subtitle: "- Romeo Kienzler",
    //   logo_path: "ibm_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/verify/BH2T9BRU87BH",
    //   alt_name: "IBM",
    //   color_code: "#1F70C199",
    // },
    // {
    //   title: "Advanced ML on GCP",
    //   subtitle: "- GCP Training",
    //   logo_path: "google_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/verify/5JZZM7TNQ2AV",
    //   alt_name: "Google",
    //   color_code: "#0C9D5899",
    // },
    // {
    //   title: "DL on Tensorflow",
    //   subtitle: "- Laurence Moroney",
    //   logo_path: "deeplearning_ai_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/verify/6T4DCUGNK8J8",
    //   alt_name: "deeplearning.ai",
    //   color_code: "#00000099",
    // },
    // {
    //   title: "Fullstack Development",
    //   subtitle: "- Jogesh Muppala",
    //   logo_path: "coursera_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/certificate/NRANJA66Y2YA",
    //   alt_name: "Coursera",
    //   color_code: "#2A73CC",
    // },
    // {
    //   title: "Kuberenetes on GCP",
    //   subtitle: "- Qwiklabs",
    //   logo_path: "gcp_logo.png",
    //   certificate_link:
    //     "https://google.qwiklabs.com/public_profiles/e4d5a92b-faf6-4679-a70b-a9047c0cd750",
    //   alt_name: "GCP",
    //   color_code: "#4285F499",
    // },
    // {
    //   title: "Cryptography",
    //   subtitle: "- Saurabh Mukhopadhyay",
    //   logo_path: "nptel_logo.png",
    //   certificate_link:
    //     "https://drive.google.com/open?id=1z5ExD_QJVdU0slLkp8CBqSF3-C3g-ro_",
    //   alt_name: "NPTEL",
    //   color_code: "#FFBB0099",
    // },
    // {
    //   title: "Cloud Architecture",
    //   subtitle: "- Qwiklabs",
    //   logo_path: "gcp_logo.png",
    //   certificate_link:
    //     "https://google.qwiklabs.com/public_profiles/5fab4b2d-be6f-408c-8dcb-6d3b58ecb4a2",
    //   alt_name: "GCP",
    //   color_code: "#4285F499",
    // },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description:
    "I have interned with various startups as a Full Stack Developer and worked with various technologies",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Internships",
      experiences: [
        {
          title: "Software Developer",
          company: "Instasell Pvt. Ltd.",
          company_url: "https://www.instasell.in/",
          logo_path: "instasell.png",
          duration: "January 2022 - May 2022",
          location: "Remote",
          description:
            "Worked on various technologies like Nextjs, React Native, Firebase, Firestore. Built a review feature from scratch. Worked on complete revamp of the app's frontend and website's frontend. Found and fixed various bugs across the app, website and backend.",
          color: "#f3837c",
        },
        {
          title: "Full Stack Developer",
          company: "Incribo Pvt Ltd",
          company_url:
            "https://www.incribo.com/",
          logo_path: "incribo.png",
          duration: "October 2021 - January 2022",
          location: "Remotes",
          description:
            "Built a wiki search feature using Wikipedia API. Redesigned the whole editing experience using react. Worked on mongoDB,redesigned the schema according to changes needed.",
          color: "#3b1c3c",
        },
      ],
    },
    {
      title: "Non-Tech",
      experiences: [
        {
          title: "Co-Founder & Chief Editor",
          company: "Protonstalk",
          company_url: "https://protonstalk.com/",
          logo_path: "protonstalk.png",
          duration: "March 2020 - Present",
          location: "Hyderabad, Telangana",
          description:
            "Built a science community of over 3,00,000 people across various social media at @protonstalk and scaled our website to 80,000 visitors a month",
          color: "#4285F4",
        },
        {
          title: "Co-Founder & Chief Growth Marketers",
          company: "Yellow Monkey Digital",
          company_url: "https://www.yellowmonkey.in/",
          logo_path: "ymd.png",
          duration: "October 2020 - September 2021",
          location: "Hyderabad, Telangana",
          description:
            "Built a marketing agency offering A-Z marketing services right from brand ideation to digital brand creation to websites, social media marketing, SEO and even printing services. Had to shut this down due to COVID",
          color: "#e9e250",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create Data Science projects and deploy them to web applications using cloud infrastructure.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  // title: "Publications",
  // description:
  //   "I have worked on and published a few research papers and publications of my own.",
  // avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "sai-teja.png",
    description:
      "I am available on almost every social media. You can message me, I will reply within 24 hours. I can help you with Full Stack Development.",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I like writing on various tech topics as it gives me a chance to dive deep into things which i just love",
    link: "https://lightmap.dev",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle:
      "Hyderabad 500035",
    avatar_image_path: "address_image.svg",
  },
  phoneSection: {
    title: "Phone Number",
    subtitle: "+91 6300322399",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  contactPageData,
};
